import { ApiError } from '~/api/errors';

/** HTTP status of a failed inspection call (the error interceptor normalises every
 *  HTTP failure to `ApiError`), or null for network/non-HTTP errors. */
export function inspectionErrorStatus(error: unknown): number | null {
  return error instanceof ApiError ? error.statusCode : null;
}

/** 404 on a `/workflows/{id}/…` route = the execution aged out of Temporal retention
 *  (or belongs to another subsidiary) — a terminal state for the panel, not a glitch. */
export function isHistoryExpired(error: unknown): boolean {
  return inspectionErrorStatus(error) === 404;
}

/** 409 = the action needs a RUNNING execution (e.g. a stack trace on a closed run). */
export function isNotRunningError(error: unknown): boolean {
  return inspectionErrorStatus(error) === 409;
}

/**
 * TanStack Query `retry` predicate: only retry what the contract marks retryable
 * (503 = Temporal/worker unreachable) and plain network failures, twice. 4xx
 * (expired 404, not-running 409, bad token 400) are final answers.
 */
export function retryInspection(failureCount: number, error: unknown): boolean {
  const status = inspectionErrorStatus(error);
  return (status === null || status === 503) && failureCount < 2;
}
